import MarketoHelper from '../application/marketo_helper';

// For RadarFirst's Marketo form, we skip opening the PDF and redirect the user instead.
class RadarFirstMarketoHelper extends MarketoHelper {
  run() {
    super.run();
  }

  handle_marketo_form_submission() {
    const that = this;
    $('body').on('click', '.mktoButton', function() {
      if (that.check_required_marketo_fields($(this)) === false) {
        return false;
      }

      $('#sent-prospect-email').val('true');
      $('#calculator-form').submit();

      that.update_status_and_submit_calculator();
      return true;
    });
  }
}

export default RadarFirstMarketoHelper;
